/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_LabelInputs */

const en_terms_label = /** @type {(inputs: Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const lv_terms_label = /** @type {(inputs: Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridiskā informācija`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Terms_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_label = /** @type {((inputs?: Terms_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_label(inputs)
	return en_terms_label(inputs)
});